import React, {useLayoutEffect, useState} from 'react'

import ProjectsReorderList from "../projects-reorder-list"
import NavigationMenuAddWithPopover from "../../../menu-items/menu-add-with-popover/menu-add"

import NavigationMenu_ProjectsLocalSettings from "../../../local-settings"
import ProjectSession from "../../../../../core/model2/project/project-session"
import NavigationMenu_ProjectsInlineAdd from "./inline-add"
import {SpaceProto} from "../../../../../core/model2/space/space-proto"
import Workspace from "../../../../../core/model2/space/workspaces/workspace"
import {
    NavigationMenuInlineAddParams,
    NavigationMenuInlineAddType
} from "../../../menu-items/menu-add-with-popover/@types"
import NavigationMenuItemEverything from "../../../menu-items/everything/menu-item-everything"
import MenuProjects_DndRoot from "../dnd/dnd-root"
import {MENU_PROJECTS_TREE_ROOT_ID} from "../dnd/@const"

// const debug = "NavigationMenuProjectsTree"
const debug = false

type Props = {
    showAdd             : boolean
    localSettings       : NavigationMenu_ProjectsLocalSettings
    // workspace?          : ProjectSession

    space               : SpaceProto

    endComponent?       : any   // rendered after the projects, before the "Everything" item (i.e. tags group)
}

type State = {
    inlineType?         : NavigationMenuInlineAddType,
    templateId?         : ID
    params              : any
}

export default function NavigationMenu_ProjectsTree(props: Props) {

    const [inlineAddParams, setInlineAddParams] = useState<any>(null)   // parameters for inline add
    const [processingAdd, setProcessingAdd] = useState<any>(false)      // is true when inline add processing is in progress and changes are awaited

    useLayoutEffect(() => {
        // if we are waiting for project to be added and treeChildren is modified then hide inline add before rerender
        if (processingAdd) {
            setInlineAddParams(null)
            setProcessingAdd(false)
        }
    }, [props.space.rootProjects.length])

    const onAddInline = (inlineType: NavigationMenuInlineAddType, params: NavigationMenuInlineAddParams) => {
        debug && console.log(debug, 'onAddInline', inlineType, params)

        setInlineAddParams({
            inlineType  : inlineType,
            params      : params, // for folder, page and embed
        })
    }

    const onInlineAdded = (isAdded: boolean) => {
        debug && console.log(debug, 'onInlineAdded', isAdded)

        if (isAdded) {
            setProcessingAdd(true)
        } else {
            setInlineAddParams(null)
        }
    }

    debug && console.log(debug, 'render() space=', props.space, props.localSettings)

    const showAddButton = props.showAdd && !inlineAddParams?.inlineType && gd.ac.check.canCreateProject(gd.companyId) && gd.ac.check.createRootProject()

    let parentId        : any = (props.space.isWorkspace) ? (props.space as Workspace).project.id : MENU_PROJECTS_TREE_ROOT_ID
    let rootProjects    : ProjectSession[] = []
    const workspace     : Workspace | undefined = (props.space.isWorkspace) ? props.space as Workspace : undefined

    if (workspace) {
        rootProjects = workspace.rootProjects
    } else {
        rootProjects = gd.session.projects.treeRootsNotWorkspaces
    }

    debug && console.log(debug, '    rootProjects=', rootProjects)

    // make sure we do not show root projects which are starred or is Section
    const starredProjects : ID[] = gd.session.starredItems.getProjectsIds() || []
    rootProjects = _.filter(rootProjects, (project:ProjectSession)=>{
        return !starredProjects.includes(project.id) && !project.isSection
    })

    const showEverythingOption  = props.space.isWorkspace
    const showInlineAdd         = inlineAddParams?.inlineType

    return (
        <>
            <MenuProjects_DndRoot>
                <ProjectsReorderList
                    level               = {0}
                    space               = {props.space}
                    // projectsSorting     = {props.space.projectsSorting}
                    // projectsColorize    = {props.space.projectsColorize}
                    parentId            = {parentId}
                    projects            = {rootProjects}
                    localSettings       = {props.localSettings}
                />
            </MenuProjects_DndRoot>

            {props.endComponent}

            {showEverythingOption &&
                <NavigationMenuItemEverything workspace={workspace!}/>}

            {showAddButton &&
                <NavigationMenuAddWithPopover
                    label       = "New"
                    projectId   = {workspace?.project.id}
                    onAddInline = {onAddInline}
                />}

            {showInlineAdd &&
                <NavigationMenu_ProjectsInlineAdd
                    callback    = {onInlineAdded}
                    parentId    = {workspace?.project.id}
                    params      = {inlineAddParams.params}
                    type        = {inlineAddParams.inlineType}
                />}
        </>
    )
}

NavigationMenu_ProjectsTree.defaultProps = {
    showAdd: true
}
